import ACCOUNT from "../../Core/TESTS/ACCOUNT";
import { ACTIONS } from "../../Models/ENUM";
import ARRAY from "../../UTIL/ARRAY";
import CONQUER from "../CONQUER";
import AvatarInstance from "./AvatarInstance";
import LOG, { log } from "../../UTIL/LOG";

class Snappy
{
    private conquer     : CONQUER;
    public avatarID     : any;
    public fullName     : any;
    public userPhoto    : any;
    public snappyFace   : any;
    public parts        : any;
    public data         : any = { color:{}, parts:{ Mouth:{ "asset":"mouth_001" } }, body:"m", snappyFace:null, userPhoto:null };
    public body         : any;
    private avatar      : AvatarInstance;
    
    private isFilled    : boolean = false;

    constructor( instance:CONQUER, avatar:AvatarInstance )
    {
        this.conquer        = instance;
        this.fullName       = avatar.fullName;
        this.avatarID       = avatar.avatarID;
        this.userPhoto      = avatar.userPhoto;
        this.avatar         = avatar;
    };
 
    public async set( data:any ) : Promise<any>
    {
        var value   = await this.conquer.do( ACTIONS.SNAPPY_SET, { avatarID:this.avatarID, data:data } );

        this.conquer.Signal.set('SNAPPY:onSet', value);

        return Promise.resolve( this.fill( value ) );
    }

    public async get() : Promise<any>
    {
        if( this.isFilled ) return Promise.resolve( this.data );

        var value   = await this.conquer.do( ACTIONS.SNAPPY_GETONE, { avatarID:this.avatarID } );
 
        return Promise.resolve( this.fill( value ) );
    }

    private fill( vars?:any )
    {
        if( vars )
        {
            ARRAY.extract( vars, this.data );
            if( vars.userPhoto ) this.avatar.userPhoto = this.userPhoto = vars.userPhoto;  
        }

        this.data.userPhoto     = this.userPhoto;
        this.data.fullName      = this.fullName;
        this.data.avatarID      = this.avatarID;
        this.body               = this.data.body;

        this.snappyFace         = this.data.snappyFace;
        this.parts              = this.data.parts;
        this.isFilled           = true;

        return this.data;
    }
}

export default Snappy;